import { initRoutes } from '@eidellev/adonis-stardust/client';
initRoutes();

import initBrowse from './modules/search/init-browse';

initBrowse();

